export default class ScreenTransitionConfig {
    getAPIPath = function () {
        return '/v2/metrics/screen_transition_data';
    };
}
